import React, { createContext, useContext, useMemo } from "react";
import { resolveCompanionProfile } from "./resolver";

const CompanionContext = createContext(null);

/**
 * CompanionProvider — mounts the active CompanionProfile at the top of the
 * shared SONMI shell. Every companion-facing name, label, and asset in
 * shared code must be read from this context, never hard-coded.
 */
export function CompanionProvider({ children }) {
  const profile = useMemo(() => resolveCompanionProfile(), []);
  return (
    <CompanionContext.Provider value={profile}>
      {children}
    </CompanionContext.Provider>
  );
}

export function useCompanion() {
  const ctx = useContext(CompanionContext);
  if (!ctx) {
    // Fail loud: shared code must be inside CompanionProvider.
    throw new Error("useCompanion() called outside CompanionProvider");
  }
  return ctx;
}
